import React, { cloneElement } from 'react'
import { Dialog, Grid } from '@mui/material'
import GetMindToolsPanel from './get-mind-tools-panel'
import { useFormFactor } from '../../hooks'

const GetMindToolsDialog = ({ open, onClose, pane }) => {
  const { isDesktop } = useFormFactor()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={isDesktop ? 'md' : 'sm'}
      fullWidth
      aria-labelledby='dialog-title'
    >
      <Grid container>
        {isDesktop && (
          <Grid item xs={5}>
            <GetMindToolsPanel />
          </Grid>
        )}
        <Grid item xs={12} lg={7}>
          {cloneElement(pane, { onClose })}
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default GetMindToolsDialog
